@switch (columnName) {
  @case ('name') {
    {{ element.matrix.user.name }}
  }
  @case ('position') {
    {{ element.matrix.position.name }}
  }
  @case ('planValidity') {
    <app-ui-pill
      [name]="VALIDATE_WORK_PLAN_STATUS_TITLES[element.matrix.validateWorkPlanStatus]"
    ></app-ui-pill>
  }
  @case ('additionalTimePeriods') {
    <button
      *ngIf="element.additionalTimesOverwrittenBySimulatedWorkPlan.length > 0"
      mat-icon-button
      [matTooltip]="'additionalTimeValidateWorkPlanWarning' | translate"
    >
      <mat-icon class="warning-container">warning</mat-icon>
    </button>
  }
  @case ('workOverviewDetails') {
    <div class="work-overview-expanded-content">
      <app-work-overview-table
        [daySchedules]="element.matrix.rows"
        [embeddedView]="true"
      ></app-work-overview-table>
    </div>
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
